import Modal from "../../../components/Modal";
import ModalWrapper from "../../../components/ModalWrapper";
import { Trans } from "@lingui/macro";
import { AutoColumn } from "../../../components/Column";
import { useCallback, useMemo, useEffect, useState } from "react";
import styled from "styled-components";
import NumericalInput from "../../../components/NumericalInput";
import AddressInput from "../../../components/AddressInput";
import Row from "../../../components/Row";
import useERC20Allowance from "../../../hooks/useERC20Allowance";
//import { MINI_POOL_ADDRESS } from "../../../constants/address";
import { USERS_ADDRESS,CPNODES_ADDRESS } from "../../../constants/address";
import useERC20Approve from "../../../hooks/useERC20Approve";
import { useWallet } from "use-wallet";

import { ButtonLight, ButtonPrimary,ButtonOutlined } from "../../../components/Button";
import Loader from "../../../components/Loader";
import useERC20Balance from "../../../hooks/useERC20Balance";
import { fromAmount, toAmount } from "../../../utils/amount";
import Big from "big.js";
import { ZERO_ADDRESS } from "../../../utils/ethereum";
const InputText = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const InputAddress = styled(AddressInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const LabelWrapper = styled.div`
  font-size: 14px;
  > * {
    display: inline-block;
  }
  
`;
const TextWrapper = styled.div`
  font-size: 14px;
  max-width: 370px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  font-size: 14px;
`;

function NodeCreateModal({
  isOpen,
  setIsOpen,
  minPledge,
  nodeOpt,
  token,
  pkgitem,
}) {
  const { account, chainId } = useWallet();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [shareAddr, setShareAddr] = useState("");

  const [nodeAddr, setNodeAddr] = useState('');
  const [nodeKey, setNodeKey] = useState('');
  const [rewardAddr, setRewardAddr] = useState(account);
  const [appgroup, setAppgroup] = useState(pkgitem.appid);
  const [desc, setDesc] = useState("");

  const tokenContract = useMemo(() => {
    if (token) {
      return token.contract;
    }
    return null;
  }, [token]);

  const balance = useERC20Balance(tokenContract, account);
  const [allowance, fetchAllowance] = useERC20Allowance(
    tokenContract,
    account,
    CPNODES_ADDRESS[chainId] // USERS_ADDRESS[chainId]
  );

  const [onApprove, approveLoading] = useERC20Approve(
    tokenContract,
    CPNODES_ADDRESS[chainId]// USERS_ADDRESS[chainId]
  );


  useEffect(() => {
    fetchAllowance();
    
    setValue(toAmount(minPledge || 0, (token && token.decimals) || 18));

  }, [
    account,
    tokenContract,
    token,
    setValue,
    minPledge,
    nodeOpt.userContract,
    fetchAllowance,
  ]);

  const handleOnApprove = useCallback(async () => {
    await onApprove(fromAmount(value || 0 , token.decimals || 18)); // minPledge
    await fetchAllowance();
  }, [fetchAllowance, onApprove, value]);

  const handlecreateWallet = useCallback(async () => {
     const {address,privateKey} = await nodeOpt.createWallet();
     setNodeKey(privateKey);
     setNodeAddr(address);
  }, [nodeOpt]);

  const handleOnPledge = useCallback(async () => {
    //console.log("getToken",await nodeOpt.getToken());
    // getNodeInfo
    const tx = await nodeOpt.createNode(
      nodeAddr,
      rewardAddr,
      appgroup,
      fromAmount(value || 0, token.decimals || 18),
      desc,
      shareAddr ? shareAddr : ZERO_ADDRESS, //todo
      setLoading,
      token == ZERO_ADDRESS ? false : true
    );
    //console.log(tx);
  }, [appgroup, desc, nodeAddr, nodeOpt, rewardAddr, shareAddr, token, value]);

  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
      {token ? (
        <ModalWrapper
          title={<Trans>Create {pkgitem.desc} Node</Trans>}
          toggleWalletModal={() => setIsOpen(false)}
        >
          <AutoColumn gap={"24px"}>
            <AutoColumn gap={"sm"}>
              <LabelWrapper>
                <Trans>Pledge Amount</Trans>
              </LabelWrapper>

              <Row>
                <InputText value={value} onUserInput={setValue} />
                <Symbol>{token.symbol}</Symbol>
              </Row>

              <BalanceWrapper>
                <Trans>
                  Balance: {toAmount(balance, token.decimals).toFixed(6, 0)}
                </Trans>{" "}
                {token.symbol}
              </BalanceWrapper>

              {/*               <LabelWrapper>
                <Trans>appgroup</Trans>
              </LabelWrapper>
                <InputAddress value={ appgroup }
                           onUserInput={ setAppgroup } /> */}

              <LabelWrapper>
                <Trans>Node Name</Trans>
     
              </LabelWrapper>
              <InputAddress value={desc} onUserInput={setDesc} />
          
              <LabelWrapper>
                <Trans>Node Address</Trans>
                <ButtonOutlined padding={'5px'} width={150} onClick={handlecreateWallet}>
                <Trans>Create Node Key</Trans>
              </ButtonOutlined> 
              </LabelWrapper>
              <InputAddress value={nodeAddr} onUserInput={setNodeAddr} />
   
              {nodeKey &&<LabelWrapper>
                <Trans>Node Key</Trans>
              </LabelWrapper>}
              {nodeKey && <TextWrapper>{nodeKey}</TextWrapper> }
              <LabelWrapper>
                <Trans>Reward Address</Trans>
              </LabelWrapper>
              <InputAddress value={rewardAddr} onUserInput={setRewardAddr} />

              {/* <LabelWrapper>
                <Trans>Referrer Address</Trans>
              </LabelWrapper>
              <InputAddress value={shareAddr} onUserInput={setShareAddr} /> */}
            </AutoColumn>

            {allowance.lt(pkgitem.minPledge || 0) ? (
              <ButtonLight disabled={approveLoading} onClick={handleOnApprove}>
                {approveLoading ? <Loader /> : <Trans>Approve</Trans>}
              </ButtonLight>
            ) : (
              <ButtonPrimary
                onClick={handleOnPledge}
                disabled={loading || !pkgitem.minPledge}
              >
                {loading && <Loader />} <Trans>Pledge</Trans>
              </ButtonPrimary>
            )}
          </AutoColumn>
        </ModalWrapper>
      ) : null}
    </Modal>
  );
}

export default NodeCreateModal;
